/**
 * Secret-aware clipboard copy shared by every surface that exposes a decrypted
 * secret value (the vault detail pane and in-chat secret cards).
 *
 * After copying a secret the clipboard is cleared 60s later — but only when it
 * still holds that exact secret (readClipboard is best-effort: if the clipboard
 * can't be read, or the user copied something else since, nothing is
 * overwritten). Keeping this in one module ensures every "copy secret" path
 * gets the auto-clear, not just the vault pane.
 */
import { copyTextToClipboard, readClipboard } from './clipboard';

let secretClearTimer = null;

export async function copySecretText(value) {
  const ok = await copyTextToClipboard(value);
  if (!ok) return false;
  if (secretClearTimer) clearTimeout(secretClearTimer);
  secretClearTimer = setTimeout(async () => {
    secretClearTimer = null;
    const { text } = await readClipboard();
    if (text === value) await copyTextToClipboard('');
  }, 60_000);
  return true;
}
